import React from "react";
import UsageCalender from './view/_usage-calender';
export default function E_HighestUsageDays() {
  return (
       <UsageCalender/>
  );
}
